import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Field, Form, Formik} from "formik";
import Loader from "../../loaders/Loader";
import {USER_PROJECT, USER_ROLE} from "../../../constants/Auth";
import {logOut} from "../../../redux/dataUploader/dataSlice";

import "react-tagsinput/react-tagsinput.css";
import './add-item.scss'
import '../../forms/UpdateConfigForm/update-config-form.scss'

const CreateCompainyPopup = ({
                          setInitialValues,
                          closePopup,
                          isPopupType,
                          setCompaniesList,
                          projectsList,
                          usersList,
                          setConfirmationMessage,
                          setConfirmationMessageText,
                          selectedUser
                      }) => {
    const dispatch = useDispatch();
    const [initialValues] = useState({
        company_full_name: '',
        project_id: '',
        company_name: '',
        company_short_name: '',
        user_name: ''
    });

    const userId = localStorage.getItem('id');
    const projectName = localStorage.getItem(USER_PROJECT);
    const role = localStorage.getItem(USER_ROLE);
    const currentItemData = useSelector((state) => state.dataUploader.voluumAlertItem);
    const [fieldsError, setFieldsError] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [formError, setFormError] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("auth_token");

    const checkSession = (status) => {
        if(status === 401) {
            dispatch(logOut());
        }
    }

    useEffect(() => {
        setIsLoading(true)
        const currentItemDataLength = Object.keys(currentItemData).length;
        if (currentItemDataLength) {
            setInitialValues(currentItemData);
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    }, [currentItemData, setInitialValues])

    const validateOther = value => {
        const regex = /^[a-zA-Z0-9 !@#$%^&*()_+\-='"\\|,.?]*$/
        if (value === '') {
            return 'Required field';
        } else if (!regex.test(value)) {
            return 'No special symbols';
        }
    }

    const onSubmit = async (values) => {
        try {
            setFieldsError(false);
            setFormLoading(true);
            setErrorMessages([]);
            
            const formData = new FormData();
            if(values.company_name) formData.append('company_name', values.company_name);
            if(values.company_short_name) formData.append('company_short_name', values.company_short_name);
            // if(!isNaN(values.project_id) && values.project_id.trim() !== "") formData.append('project_id', values.project_id);
            if(values.company_full_name) formData.append('company_full_name', values.company_full_name);
            // if(!isNaN(values.user_name) && values.user_name.trim() !== "") formData.append('user_id', values.user_name);
            formData.append('user_id', selectedUser.id);
            
            const res = await fetch(`${localStorage.getItem('apiUrl')}api/companies/store?per_page=1000`, {
                method: 'POST',
                headers: { 
                    "Authorization": `Bearer ${token}` 
                },
                body: formData
            });
            
            checkSession(res.status);

            const data = await res.json();
            
            if(data.status === 'success') {
                setCompaniesList(data?.companies?.data || []);
                closePopup();
                setConfirmationMessage(true);
                setConfirmationMessageText(`Compain ${values.company_name} successfully created`);
            } else {
                const errors = Object.values(data.errors).flat().map(String).map(s => s.trim()).filter(Boolean);
                setFieldsError(true);
                setErrorMessages(errors);
            }
        } catch (error) {
            console.error("Server connection error:", error);
            setFieldsError(true);
        } finally {
            setFormLoading(false);
        }
    }

    return (
        <div className='add-item-popup-container'>
            <div className="add-item-popup-block">
                <div className='form-wrap'>
                    <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        onSubmit={onSubmit}>
                        {({errors, touched}) => (
                            <Form>
                                <div className="title-wrap">
                                    <h1>
                                        Create new Campaign
                                    </h1>
                                    <div className="close-btn" onClick={() => closePopup(false)}>
                                        <img src={`${process.env.PUBLIC_URL}/images/close-btn.svg`} alt="close popup"/>
                                    </div>
                                </div>
                                {
                                    isLoading ?
                                        <Loader/>
                                        :
                                        <>
                                            <div className="form-flex-container">
                                                {Object.keys(initialValues)
                                                .map(inputItem => {
                                                    // if (role === 'admin' && inputItem === 'user_name') {
                                                    //     return (
                                                    //         <div
                                                    //             className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                    //             key={inputItem}>
                                                    //             <label htmlFor={inputItem}
                                                    //                     className="toggle-label">User Name</label>
                                                    //             <Field as="select" name={inputItem}>
                                                    //                 <option key={inputItem}
                                                    //                                 value='def'>Chose User name</option>
                                                    //                 {Object.entries(usersList)
                                                    //                 .sort((a, b) => String(a[1]).localeCompare(String(b[1]), undefined, { sensitivity: "base" }))
                                                    //                 .map(([id, name]) => (
                                                    //                     <option key={id} value={id}>
                                                    //                         {name}
                                                    //                     </option>
                                                    //                 ))}
                                                    //             </Field>
                                                    //         </div>
                                                    //     )
                                                    // } else if (role !== 'admin' && inputItem === 'user_name') return null;

                                                    if(inputItem === 'project_id' || inputItem === 'user_name') return null;

                                                    if (inputItem === 'company_full_name') {
                                                        return (
                                                            <div className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                                 key={inputItem}>
                                                                <label htmlFor={inputItem}>{inputItem.replace(/[_\-\s]+/g, ' ')}</label>
                                                                <Field
                                                                    id={inputItem}
                                                                    name={inputItem}
                                                                    validate={validateOther}
                                                                />
                                                                {errors[inputItem] && touched[inputItem] ? <div
                                                                    className='form-error'>{errors[inputItem]}</div> : null}
                                                            </div>
                                                        )
                                                    }

                                                    if (inputItem === 'project_id') {
                                                        return (
                                                            <div
                                                                className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                                key={inputItem}>
                                                                <label htmlFor={inputItem}
                                                                        className="toggle-label">Project</label>
                                                                <Field as="select" 
                                                                    name={inputItem}
                                                                    validate={validateOther}
                                                                    >
                                                                    <option value='def'>Choose Project Name</option>
                                                                    {[...projectsList]
                                                                    .sort((a, b) => String(a.name).localeCompare(String(b.name), undefined, { sensitivity: "base" }))
                                                                    .map((option) => {
                                                                        return (
                                                                            <option key={option.id}
                                                                                    value={option.id}>{option.name}</option>
                                                                        )
                                                                    })}
                                                                </Field>
                                                                {errors[inputItem] && touched[inputItem] ? <div
                                                                    className='form-error'>{errors[inputItem]}</div> : null}
                                                            </div>
                                                        )
                                                    }                                                

                                                    return (
                                                        <div className={`input-block without-config-item-block${errors[inputItem] && touched[inputItem] ? ' form-error' : ''}`}
                                                             key={inputItem}>
                                                            <label htmlFor={inputItem}>{inputItem.replace(/[_\-\s]+/g, ' ')}</label>
                                                            <Field
                                                                id={inputItem}
                                                                name={inputItem}
                                                                type='text'
                                                            />
                                                            {errors[inputItem] && touched[inputItem] ? <div
                                                                className='form-error'>{errors[inputItem]}</div> : null}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div className="config-btns-block">
                                                <div className="discard-btn" onClick={() => closePopup(false)}>Discard</div>
                                                <button className='update-btn'
                                                    type="submit">Create</button>
                                            </div>
                                        </>
                                }
                            </Form>
                        )}
                    </Formik>
                    {formLoading ? <div className="config-btns-loader-block"><Loader/></div> : null}
                    {fieldsError ?
                        <div className="config-btns-message-block">
                            {errorMessages.map((item, index) => {
                                return <p key={item[index]} className='new-user-error'>{item}</p>
                            })}
                        </div> : ''}
                    {formError ?
                        <div className="config-btns-message-block"><p className='new-user-error'>Some error occurred</p>
                        </div> : ''}
                    {formSuccess ? <div className="config-btns-message-block"><p className='new-user-success'>Account
                        is {isPopupType === 'updating' ? 'updated' : 'created'}</p></div> : ''}
                </div>
            </div>
        </div>
    )
}

export default CreateCompainyPopup;